export default __webpack_public_path__ + "static/media/foto1.34d3e904.png";